export const ELanguagens = {
  PortugueseBr: 0,
}

export type ELanguagens = (typeof ELanguagens)[keyof typeof ELanguagens]
